exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-molecules-LimitTextAreaField-___LimitTextAreaField__restTextLength___1kEok {\n  color: #ee82ab;\n  font-size: 15px;\n  font-weight: normal;\n  pointer-events: none;\n  text-align: right;\n  -webkit-transition: 0.2s ease all;\n  transition: 0.2s ease all;\n}\n", ""]);

// exports
exports.locals = {
	"restTextLength": "src-pc-components-molecules-LimitTextAreaField-___LimitTextAreaField__restTextLength___1kEok"
};